import React, { useEffect, useState } from "react";
import router, { withRouter } from "next/router";
import { WithRouterProps } from "next/dist/client/with-router";
import { SuccessContainer, ImageContainer, CustomSubmitButton, BoldWhiteSpan, CTAForthContainer } from "./Success.styles";
import { TitleSubtitle } from "../../TitleSubtitle/TitleSubtitle";
import { readUpcomingShow } from "../../../services/ShowService";
import { Typography } from "@mui/material"
import { welcomeMessageTemplate } from "../../../utils/constants";
import { formatString } from "../../../utils/string-utils";
import Image from "next/image";

interface SuccessProps extends WithRouterProps {
    firstName?: string;
}

const Success: React.FC<SuccessProps> = ({
    firstName
}) => {
    const [upcomingShowUrl, setUpcomingShowUrl] = useState<string | undefined>("");
    const [redirectUrl,setRedirectUrl] = useState<string | null>(null);

    readUpcomingShow().then((upcomingShow) => {
        if (upcomingShow.data) {
            setUpcomingShowUrl(upcomingShow.data?.publicRouteUrL);
        }
    });

    useEffect(() => {
        setRedirectUrl(window.localStorage.getItem("redirectURL"))
    }, []);
    
    return (
        <SuccessContainer>
            <ImageContainer>
                <Image fill alt="Party Bird - TTT" src="/images/email/gifs/party_bird.gif" />
            </ImageContainer>
            <TitleSubtitle
                data-cy="success-title-subtitle"
                size="sm"
                centered
                title={formatString(welcomeMessageTemplate, firstName || '')}
                subTitle={<>
                    <br />You’ve just unlocked the <BoldWhiteSpan>best-kept secret</BoldWhiteSpan> in television!<br /><br />

                    Forget the couch; you’re not just a viewer - you’re a ⭐ of the show! <br /><br />

                    You’ll now be the first to know about  <BoldWhiteSpan>free tickets</BoldWhiteSpan> to upcoming shows.<br /><br />

                    We often drop a cheeky last-minute ticket on our socials - <BoldWhiteSpan>follow us</BoldWhiteSpan> for the inside scoop.<br /><br />

                    #TTTicketAU
                </>} />

            <CTAForthContainer>
                {/* redirectUrl from Localstorge seems to be buggy. TODO: Revisit this later
                    {redirectUrl ?
                    <CustomSubmitButton
                        onClick={() => {
                            router.push(redirectUrl);
                        }}
                        full
                    >
                        Continue 
                    </CustomSubmitButton> :*/}
                    <CustomSubmitButton
                        onClick={() => router.push(`/audience`)}
                        full
                    >
                        Explore Upcoming Shows
                    </CustomSubmitButton>
                {/* } */}
                <CustomSubmitButton
                    onClick={() => router.push(`/profile?tab=tickets`)}
                    full
                >
                    I’ve Already Got a Ticket Offer
                </CustomSubmitButton>
            </CTAForthContainer>
        </SuccessContainer>
    );
};

Success.displayName = "Success";

const ComponentWithRouter = withRouter(Success)

export { ComponentWithRouter as Success };